import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withSizes } from 'react-sizes';
import { openModal, failValidationDateCheck } from '../../redux/actions';
import { startValidation } from '../../redux/actions/ticket';
import { StaffValidate } from '../index';
import { Button } from '../../components';
import { Person, Calendar, Clock, Check, Kids, Parking, Coupone, getProductTypeName, getIconByProductType, getBookingStatus, getKids, objectIsEmpty } from '../../utils';

import {
  BookingPanelArticle,
  BookingPanelTable,
  BookingInfo,
  BookingList,
  BookingItem,
  BookingIcon,
  BookingId,
  Divider,
  StatusIcon,
  ValidateButtonContainer,
  PromoContainer,
  PromoIcon,
  PromoInfo,
  PromoHeading,
  PromoDescription,
  QuestionTooltipBlockBooking,
  ServiceFeeToolTipBooking,
} from './styles';

const BookingPanelContainer = ({ children, validationStep, bookingId, isTablet }) => <BookingPanelArticle>{validationStep === 'initial' && isTablet ? children : <StaffValidate bookingId={bookingId} />}</BookingPanelArticle>;

BookingPanelContainer.propTypes = {
  children: PropTypes.node.isRequired,
  validationStep: PropTypes.string,
  bookingId: PropTypes.number,
  isTablet: PropTypes.bool,
};

const mapSizesToProps = ({ width }) => ({
  isTablet: width >= 768,
});

const getStatus = (status, expiration, redeemedDate, canceledDate, timeZone) => {
  const formatTemplate = 'ha MMM DD z';
  if (!expiration || !timeZone) {
    return <Fragment>Status Unavailable for now.</Fragment>;  // Handle missing data appropriately
  }

  switch (status) {
    case 0:
      return (
        <Fragment>
          Expires {moment(expiration).isValid() ? moment(expiration).tz(timeZone).format(formatTemplate) : 'Invalid Date'}
        </Fragment>
      );
    case 1:
      return (
        <Fragment>
          Expired on {moment(expiration).isValid() ? moment(expiration).tz(timeZone).format(formatTemplate) : 'Invalid Date'}
        </Fragment>
      );
    case 2:
      return (
        <Fragment>
          Redeemed on {moment(redeemedDate).isValid() ? moment(redeemedDate).tz(timeZone).format(formatTemplate) : 'Invalid Date'}
        </Fragment>
      );
    case 3:
      return (
        <Fragment>
          Cancelled on {moment(canceledDate).isValid() ? moment(canceledDate).tz(timeZone).format(formatTemplate) : 'Invalid Date'}
        </Fragment>
      );
    default:
      return (
        <Fragment>
          Expires {moment(expiration).isValid() ? moment(expiration).tz(timeZone).format(formatTemplate) : 'Invalid Date'}
        </Fragment>
      );
  }
};


const BookingInfoContainer = ({ guestName, productAmount, productType, date, status, expiration, timeZone, redeemedDate, canceledDate }) => (
  <Fragment>
    <BookingInfo>
      <BookingList>
        <BookingItem>
          <BookingIcon>
            <Person color="#505050" />
          </BookingIcon>
          <span>
            {productType !== 1 && productAmount !== 1 && <Fragment>{productAmount} guests</Fragment>}
            {' '}
            {guestName && (
              <Fragment>
                {productType !== 1 && productAmount !== 1 && '('}{guestName}{productType !== 1 && productAmount !== 1 && ')'}
              </Fragment>
            )}
          </span>
        </BookingItem>
        <BookingItem>
          <BookingIcon>
            {getIconByProductType(productType)}
          </BookingIcon>
          <span>{productAmount} {getProductTypeName(productType, productAmount).toLowerCase()}</span>
        </BookingItem>
        <BookingItem>
          <BookingIcon>
            <Calendar color="#505050" />
          </BookingIcon>
          <span>{moment(date).format('MMM DD, YYYY')}</span>
        </BookingItem>
        <BookingItem>
          <StatusIcon status={status}>{getBookingStatus(status)}</StatusIcon>
          <span>{getStatus(status, expiration, redeemedDate, canceledDate, timeZone)}</span>
        </BookingItem>
      </BookingList>
    </BookingInfo>
    <Divider />
  </Fragment>
);

BookingInfoContainer.propTypes = {
  guestName: PropTypes.string,
  productAmount: PropTypes.number,
  productType: PropTypes.number,
  date: PropTypes.string,
  status: PropTypes.number,
  expiration: PropTypes.string,
  timeZone: PropTypes.string,
  redeemedDate: PropTypes.string,
  canceledDate: PropTypes.string,
};

const HotelInfoContainer = ({ workingHours, checkIn, isKidAllowed, parking }) => (
  <BookingInfo>
    <BookingList>
      <BookingItem>
        <BookingIcon>
          <Clock color="#505050" />
        </BookingIcon>
        <span>{workingHours}</span>
      </BookingItem>
      <BookingItem>
        <BookingIcon>
          <Check color="#505050" />
        </BookingIcon>
        <span>Check-in: {checkIn}</span>
      </BookingItem>
      <BookingItem>
        <BookingIcon>
          <Kids color="#505050" />
        </BookingIcon>
        <span>Children: {getKids(isKidAllowed)}</span>
      </BookingItem>
      {parking && (
        <BookingItem>
          <BookingIcon>
            <Parking color="#505050" />
          </BookingIcon>
          <span style={{ marginLeft: 5 }} dangerouslySetInnerHTML={{ __html: parking }} />
        </BookingItem>
      )}
    </BookingList>
  </BookingInfo>
);

HotelInfoContainer.propTypes = {
  workingHours: PropTypes.string,
  checkIn: PropTypes.string,
  isKidAllowed: PropTypes.number,
  parking: PropTypes.string,
};
const getPromoAmount = (promo, price, productAmount) => {
  const total = price * productAmount;

  if (promo.type === 0) {
    return total * promo.amount / 100;
  }

  return promo.amount;
};

const getPromo = (promo, price, productAmount) => {

  return (
    <li style={{ color: '#11d17d' }}>
      <div>{promo.discountName} {promo.type === 0 && (`(-${promo.amount}% OFF)`)}</div>
      <div>-${getPromoAmount(promo, price, productAmount).toFixed(2)}</div>
    </li>
  );
};

const getPaidBy = (paidBy) => {
  if (objectIsEmpty(paidBy)) {
    return (
      <li>
        <Fragment>
          <div>Paid by</div>
          <div>----</div>
        </Fragment>
      </li>
    )
  }

  if (typeof paidBy.name === 'undefined') {
    return (
      <li>
        <Fragment>
          <div>Paid by</div>
          <div>PayPal</div>
        </Fragment>
      </li>
    )
  }

  return (
    <li>
      <Fragment>
        <div>{paidBy.name}</div>
        <div>•••• {paidBy.value}</div>
      </Fragment>
    </li>
  );
};

const PaymentInfoContainer = ({ paymentFee, checkinDate, setValidationErr, validationError, price, productAmount, productType, promo, tax, credit, bookingId, total, paidBy, bookingDate, isTablet, handleValidationClick, onModalOpenClick, status, freeProductAmount }) => (
  <Fragment>
    <BookingPanelTable>
      {freeProductAmount !== 0 && productAmount >= 1 && (
        <Fragment>
          <li>
            <div>
              $0.00 x {(freeProductAmount)} {getProductTypeName(productType, productAmount)}
            </div>
            <div>
              $0.00
            </div>
          </li>
          <Divider />
        </Fragment>
      )}
      <li>
        <div>
          ${price.toFixed(2)} x {productAmount || 1} {getProductTypeName(productType, productAmount)}
        </div>
        <div>
          ${(price * productAmount).toFixed(2)}
        </div>
      </li>
      {promo !== undefined && getPromo(promo, price, productAmount)}
      {tax !== 0 && (
        <li>
          <div>Tax</div>
          <div>${tax.toFixed(2)}</div>
        </li>
      )}
      {paymentFee && paymentFee !== 0 ? (
        <li>
          <div>Service Fee
            <ServiceFeeToolTipBooking
              content="This helps us run our platform and offer services like 24/7 support on your trip"
              placement="top"
              fadeDuration={10}
              padding={15}
              radius={8}
              fontSize='12px'
              background="#ffffff"
              color="#5a5a5a"
              border="#ebebeb">
              <QuestionTooltipBlockBooking>?</QuestionTooltipBlockBooking>
            </ServiceFeeToolTipBooking>
          </div>
          <div>
            ${paymentFee.toFixed(2)}
          </div>
        </li>
      ) : null}
      {credit !== 0 && (
        <li>
          <div>Credit</div>
          <div>-${credit.toFixed(2)}</div>
        </li>
      )}
    </BookingPanelTable>
    <Divider />
    {isTablet && (
      <BookingPanelTable>
        <li>
          <div>Total paid</div>
          <div>
            <span>${(total - credit).toFixed(2)}</span>
          </div>
        </li>
      </BookingPanelTable>
    )}
    {!isTablet && (
      <BookingPanelTable>
        <li>
          <div>Total paid</div>
          <div>
            <span>${(total - credit).toFixed(2)}</span>
          </div>
        </li>
        {getPaidBy(paidBy)}
        <li>
          <div>Booked on</div>
          <div>{moment(bookingDate).format('MMM DD, YYYY')}</div>
        </li>
      </BookingPanelTable>
    )}
    <ValidateButtonContainer>
      {status === 2 ? (
        <Button htmlType="button" theme="primary" disabled>Validated</Button>
      ) : (
        <Fragment>
          <Button htmlType="button" theme="primary" onClick={() => {if(!moment().isSame(moment(checkinDate),'day')) {setValidationErr('Today is before checkin date.')} else { isTablet ? handleValidationClick() : onModalOpenClick('validation'); handleValidationClick() }}}>Staff Validate</Button>
          {validationError && <p>{validationError}</p>}
        </Fragment>
      )}
    </ValidateButtonContainer>
    {isTablet && <BookingId>Booking ID: <span>{bookingId}</span></BookingId>}
    {isTablet && (
      <BookingPanelTable>
        {getPaidBy(paidBy)}
        <li>
          <div>Booked on</div>
          <div>{moment(bookingDate).format('MMM DD, YYYY')}</div>
        </li>
      </BookingPanelTable>
    )}
    {promo !== undefined && (
      <Fragment>
        <Divider />
        <PromoContainer>
          <PromoIcon>
            <Coupone />
          </PromoIcon>
          <PromoInfo>
            <PromoHeading>{promo.discountName}</PromoHeading>
            <PromoDescription>{promo.type === 0 && (`(-${promo.amount}% OFF)`)}</PromoDescription>
          </PromoInfo>
        </PromoContainer>
      </Fragment>
    )}
  </Fragment>
);

PaymentInfoContainer.propTypes = {
  price: PropTypes.number,
  productAmount: PropTypes.number,
  productType: PropTypes.number,
  promo: PropTypes.instanceOf(Object),
  tax: PropTypes.number,
  credit: PropTypes.number,
  bookingId: PropTypes.string,
  total: PropTypes.number,
  paidBy: PropTypes.instanceOf(Object),
  bookingDate: PropTypes.string,
  checkinDate: PropTypes.string,
  isTablet: PropTypes.bool,
  handleValidationClick: PropTypes.func,
  onModalOpenClick: PropTypes.func,
  setValidationErr: PropTypes.func,
  status: PropTypes.number,
  validationError: PropTypes.string,
  freeProductAmount: PropTypes.number,
  paymentFee: PropTypes.number,
};

const mapStateToProps = state => ({
  validationStep: state.validation.status,
  validationError: state.validation.dateCheckMessage,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  handleValidationClick: startValidation,
  onModalOpenClick: openModal,
  setValidationErr: failValidationDateCheck,
}, dispatch);

class BookingPanel extends Component {
  static BookingPanelContainer = connect(mapStateToProps)(withSizes(mapSizesToProps)(BookingPanelContainer));

  static BookingInfo = connect(mapStateToProps)(BookingInfoContainer);

  static HotelInfo = HotelInfoContainer;

  static PaymentInfo = connect(mapStateToProps, mapDispatchToProps)(PaymentInfoContainer);

  static BookingDivider = Divider;

  render() {
    return null;
  }
}

export default BookingPanel;
